import { CreateThread } from '@/screens/create-thread';

export default function NewThreadScreen() {
  return <CreateThread />;
}
